import { z } from 'zod';

import type { CompanyId, Matter, MatterId } from '@chariot/core-domain';
import { brandId, type Branded } from '@chariot/core-ids';

export { UTC, calendarDateSchema, instantSchema, timeZoneSchema } from './date';
export {
  ROLES,
  permissionSchema,
  permissionsForRoles,
  roleSchema,
  sessionSchema,
  type Permission,
  type Role,
  type Session,
} from './authz';

const brandedUuid = <T extends string>(brand: T): z.ZodType<Branded<T>, string> =>
  z.uuid().transform((value) => brandId(brand, value));

export const companyIdSchema: z.ZodType<CompanyId, string> = brandedUuid('CompanyId');
export const matterIdSchema: z.ZodType<MatterId, string> = brandedUuid('MatterId');

export const matterSchema = z.object({
  id: matterIdSchema,
  companyId: companyIdSchema,
  displayNumber: z.string().min(1),
}) satisfies z.ZodType<Matter>;

export type MatterPayload = z.output<typeof matterSchema>;
